import { Fragment } from "react";
import type { GetIssuesWithActionsQuery } from "@medbillai/generated-graphql-types";
import { Separator, YStack } from "@medbillai/ui";
import { IssueSummary } from "./IssueSummary";
import { Divider } from "./WidgetWrapper";
type IssuesArray = NonNullable<NonNullable<GetIssuesWithActionsQuery["me"]>["issues"]>;
type Issue = IssuesArray[number];
interface IssuesWithActionsWidgetProps {
  issues: Issue[];
}
export function IssuesWithActionsWidget({
  issues
}: IssuesWithActionsWidgetProps) {
  if (issues.length === 0) {
    return null;
  }
  return <YStack data-sentry-element="YStack" data-sentry-component="IssuesWithActionsWidget" data-sentry-source-file="IssuesWithActionsWidget.tsx">
      {issues.map((issue, index) => <Fragment key={issue.id}>
          <IssueSummary issue={issue} stackProps={{
        paddingHorizontal: "$sp2.5"
      }} />
          {index !== issues.length - 1 ? <Separator mx="$sp2.5" /> : null}
        </Fragment>)}
      <Divider data-sentry-element="Divider" data-sentry-source-file="IssuesWithActionsWidget.tsx" />
    </YStack>;
}